/* ============================================================================
   Creator Commerce — scroll pop-up controller.

   Loaded only on pages where a creator resolved (see snippets/cc-creator.liquid).
   Reads its configuration from the #cc-creator-data JSON block rather than from
   inlined Liquid, so no creator-supplied string is ever interpolated into
   executable JavaScript.

   Behaviour, per the brief:
     - fires only after the visitor scrolls past the "What proper hydration feels
       like" section (.rad-section);
     - one tap applies the creator's discount and flips the button to
       "Discount applied", then it stops prompting;
     - dismissible with the X.
   Both "applied" and "dismissed" are remembered for the session, keyed by creator
   handle, so it does not re-prompt on the next page view.
   ========================================================================== */
(function () {
  'use strict';

  var pop = document.getElementById('cc-pop');
  if (!pop) return;

  var dataEl = document.getElementById('cc-creator-data');
  var cfg = {};
  try { cfg = JSON.parse((dataEl && dataEl.textContent) || '{}'); } catch (e) { cfg = {}; }

  var btn = document.getElementById('cc-pop-btn');
  var closeBtn = document.getElementById('cc-pop-close');
  if (!btn || !closeBtn) return;

  var handle = cfg.handle || 'cc';
  var KEY = 'cc-pop:' + handle;

  /* sessionStorage throws in some privacy modes — never let that stop the page. */
  function readState() {
    try { return window.sessionStorage.getItem(KEY) || ''; } catch (e) { return ''; }
  }
  function writeState(v) {
    try { window.sessionStorage.setItem(KEY, v); } catch (e) { /* no-op */ }
  }

  var settled = readState() === 'applied' || readState() === 'dismissed';
  var applied = readState() === 'applied';
  var hideTimer = null;

  /* The trigger is the radial-benefits section — "What proper hydration feels
     like". If that section is ever renamed or removed the pop-up falls back to a
     plain scroll depth so it still appears rather than silently never firing. */
  var trigger = document.querySelector(pop.getAttribute('data-cc-trigger') || '.rad-section');

  function scrolledPast() {
    if (trigger) return trigger.getBoundingClientRect().bottom < window.innerHeight * 0.9;
    return (window.pageYOffset || document.documentElement.scrollTop) > window.innerHeight * 1.5;
  }

  function open() {
    if (pop.classList.contains('is-open')) return;
    pop.classList.add('is-open');
    pop.removeAttribute('aria-hidden');
  }
  function close() {
    pop.classList.remove('is-open');
    pop.setAttribute('aria-hidden', 'true');
  }

  function check() {
    if (settled) { detach(); return; }
    if (scrolledPast()) open();
  }

  function detach() {
    window.removeEventListener('scroll', check);
    window.removeEventListener('resize', check);
  }

  /* Applying the discount: Shopify's /discount/<code> endpoint sets the discount
     for the session and then redirects. Fetching it keeps the shopper on the
     page — a plain link would throw them back to the homepage mid-scroll. If the
     request fails (offline, blocked), fall through to the navigation the endpoint
     was designed for rather than telling the shopper it worked when it did not. */
  function applyDiscount() {
    if (applied || !cfg.code) return;
    applied = true;
    writeState('applied');

    var url = '/discount/' + encodeURIComponent(cfg.code) + '?redirect=' +
              encodeURIComponent(window.location.pathname + window.location.search);

    var done = function () {
      pop.classList.add('is-applied');
      btn.textContent = '✓  Discount applied at checkout';
      btn.setAttribute('disabled', 'disabled');
      settled = true;
      detach();
      /* Flipped, acknowledged, then it stops prompting. */
      hideTimer = window.setTimeout(close, 4000);
    };

    if (window.fetch) {
      window.fetch(url, { credentials: 'same-origin' })
        .then(done)
        .catch(function () { window.location.href = url; });
    } else {
      window.location.href = url;
    }
  }

  btn.addEventListener('click', applyDiscount);

  closeBtn.addEventListener('click', function () {
    settled = true;
    writeState('dismissed');
    if (hideTimer) window.clearTimeout(hideTimer);
    close();
    detach();
  });

  if (settled) {
    /* Already handled earlier in the session: show the settled state if the
       shopper opens the card again, but never prompt unprompted. */
    if (applied) {
      pop.classList.add('is-applied');
      btn.textContent = '✓  Discount applied at checkout';
      btn.setAttribute('disabled', 'disabled');
    }
  } else {
    window.addEventListener('scroll', check, { passive: true });
    window.addEventListener('resize', check);
    check();
  }
})();
